import jsPDF from "jspdf";
import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import AbstractPdfDocument from "../../../../../lib/html5-software-library/src/ranj/pdf/documents/AbstractPdfDocument";
import Config from "../../../core/config/Config";
import PlayerModel from "../../player/model/PlayerModel";
import ScoreService from "../../score/controller/ScoreService";
import PersonalReportConfig from "../model/PersonalReportConfig";
import PersonalReportModel from "../model/PersonalReportModel";
import "./fonts/Roboto-Bold-normal";
import "./fonts/Roboto-Italic-normal";
import "./fonts/Roboto-Regular-normal";
import ExploreFurtherSection from "./sections/ExploreFurtherSection";
import HeaderSection from "./sections/HeaderSection";
import PerformanceSection from "./sections/PerformanceSection";
import ScoreSection from "./sections/ScoreSection";
import TipsSection from "./sections/TipsSection";

export default class PersonalReportPdfDocument extends AbstractPdfDocument {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {PersonalReportConfig} personalReportConfig 
     * @param {LanguagePack} languagePack 
     * @param {Config} config
     * @param {ScoreService} scoreService
     * @param {PlayerModel} playerModel
     * @param {PersonalReportModel} personalReportModel
     */
    constructor(dispatcher, personalReportConfig, languagePack, config, scoreService, playerModel, personalReportModel) {
        super(dispatcher, personalReportConfig);

        this._languagePack = languagePack;
        this._config = config;
        this._playerModel = playerModel;
        this._scoreService = scoreService;
        this._personalReportModel = personalReportModel;

        /** @type {{ id: string, maxValue: number }[]} */
        this._trackerConfiguration = this._config.getValue(`trackers`);

        this._documentSections = this._createSections();
    }

    async loadData() {
        const loadingPromises = this._documentSections.map(section => section.loadData());
        await Promise.all(loadingPromises);
    }

    initialize() {
        super.initialize();

        this.setFilename(this._languagePack.getText("personalReport.fileName"));

        for (const section of this._documentSections) {
            this.addSection(section);
        }
    }

    _createSections() {
        return [
            new HeaderSection(this._pdfConfig, this._languagePack),
            new ScoreSection(this._pdfConfig, this._languagePack, this._playerModel, this._scoreService),
            new PerformanceSection(this._pdfConfig, this._languagePack, this._personalReportModel),
            new TipsSection(this._pdfConfig, this._languagePack, this._personalReportModel),
            new ExploreFurtherSection(this._pdfConfig, this._languagePack),
        ];
    }

    /**
     * @param {jsPDF} doc 
     * @param {number} pageIndex 
     */
    _drawFooter(doc, pageIndex) {
        // Draw logo.
        const logoStyle = this._pdfConfig.getValue("elements.footer.logo");
        const logoImageData = this._pdfConfig.getValue("imageData.logo").data;
        doc.addImage(logoImageData, "PNG", this._pageWidth * .5, this._footerY, logoStyle.width, logoStyle.height);

        // Draw page number.
        const style = this._pdfConfig.getValue("elements.footer");
        const font = style.footerText;
        doc.setFont(font.family, "normal");
        doc.setFontSize(font.size);
        doc.setTextColor(font.color[0], font.color[1], font.color[2]);

        doc.text(`${pageIndex}`, this._pageWidth + this._pageMarginH - 5, this._footerY + 8, "right");
    }
}